import RuleParameterAlias from './rule-parameter-alias.entity';

export default class RuleAliasSummary {
  ruleId: string;

  alias: string;

  currentAlias: string;

  replaceAll: boolean = false;

  parameters: RuleParameterAlias[];

  constructor(obj: any) {
    this.ruleId = obj.ruleId || '';
    this.currentAlias = obj.alias || '';
    this.alias = obj.alias || '';
    this.parameters = obj.parameters ? RuleParameterAlias.ofList(obj.parameters) : [];
  }

  static of(obj: any): RuleAliasSummary {
    return new RuleAliasSummary(obj || {})
  }

  static ofList(obj: any[]): RuleAliasSummary[] {
    return obj.map(this.of)
  }
}
